import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { ProgressbarModule } from "ngx-bootstrap/progressbar";

import { lottiePlayerFactory } from "../app.module";

import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";

// import { LottieComponent } from "ngx-lottie";
import player from "lottie-web";

export function playerFactory() {
  return player;
}
@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [],
  exports: [],
  imports: [
    CommonModule,
    ProgressbarModule,
    FormsModule,
    RouterModule,

    // LottieModule.forRoot({ player: lottiePlayerFactory }),
  ],
})
export class SharedModule {}
